/**
 * Infinite Scroll / Load More functionality for Collection pages
 */
(function() {
  'use strict';

  var InfiniteScroll = function(container) {
    this.container = container;
    this.paginationType = container.getAttribute('data-pagination-type');

    if (this.paginationType === 'paginated') {
      return;
    }

    this.productGrid = document.getElementById('CollectionProductGrid');
    this.scrollContainer = container.querySelector('[data-infinite-scroll]');

    if (!this.scrollContainer) {
      return;
    }

    this.nextUrl = this.scrollContainer.getAttribute('data-next-url');
    this.currentPage = parseInt(this.scrollContainer.getAttribute('data-current-page'), 10);
    this.totalPages = parseInt(this.scrollContainer.getAttribute('data-total-pages'), 10);
    this.isLoading = false;
    this.allLoaded = this.currentPage >= this.totalPages;

    this.init();
  };

  InfiniteScroll.prototype = {
    init: function() {
      if (this.allLoaded) {
        this.markAllLoaded();
        return;
      }

      if (this.paginationType === 'load_more') {
        this.initLoadMore();
      } else if (this.paginationType === 'infinite_scroll') {
        this.initInfiniteScroll();
      }

      // Listen for collection reloads (filters, sorting)
      document.addEventListener('collection:reloaded', this.onCollectionReloaded.bind(this));
    },

    initLoadMore: function() {
      var loadMoreBtn = this.scrollContainer.querySelector('[data-load-more-btn]');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', this.loadNextPage.bind(this));
      }
    },

    initInfiniteScroll: function() {
      var trigger = this.scrollContainer.querySelector('[data-infinite-scroll-trigger]');
      if (!trigger) {
        return;
      }

      // Use Intersection Observer for infinite scroll
      var options = {
        root: null,
        rootMargin: '200px',
        threshold: 0
      };

      this.observer = new IntersectionObserver(this.onIntersection.bind(this), options);
      this.observer.observe(trigger);
    },

    onIntersection: function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !this.isLoading && !this.allLoaded) {
          entry.target.classList.add('is-visible');
          this.loadNextPage();
        }
      }.bind(this));
    },

    loadNextPage: function() {
      if (this.isLoading || this.allLoaded || !this.nextUrl) {
        return;
      }

      this.isLoading = true;
      this.setLoadingState(true);

      var url = this.nextUrl;
      // Add view=ajax to get section rendering
      if (url.indexOf('?') === -1) {
        url += '?view=ajax';
      } else {
        url += '&view=ajax';
      }

      fetch(url)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          this.appendProducts(html);
          this.updatePagination();
          this.isLoading = false;
          this.setLoadingState(false);
        }.bind(this))
        .catch(function(error) {
          console.error('Infinite scroll error:', error);
          this.isLoading = false;
          this.setLoadingState(false);
        }.bind(this));
    },

    appendProducts: function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      // Find the product grid in the loaded content
      var newProductGrid = doc.getElementById('CollectionProductGrid');
      if (!newProductGrid) {
        // Fallback: try to find grid-product items directly
        newProductGrid = doc.querySelector('.collection-grid');
      }

      if (newProductGrid) {
        // SOLO i product item reali. Mai la sidebar (.sidebar > .grid__item--{id})
        // e mai i wrapper di subnav. La sidebar va resa una sola volta in pagina.
        var newProducts = newProductGrid.querySelectorAll('.product-grid-container .grid-product, .product-grid-container .grid__item');
        if (newProducts.length === 0) {
          newProducts = newProductGrid.querySelectorAll('.grid-product');
        }
        var currentGrid = this.productGrid.querySelector('.product-grid-container') ||
                          this.productGrid.querySelector('.collection-grid, .grid');

        if (currentGrid && newProducts.length > 0) {
          var seenIds = {};
          currentGrid.querySelectorAll('.grid-product[data-product-id]').forEach(function(el) {
            seenIds[el.getAttribute('data-product-id')] = true;
          });

          newProducts.forEach(function(product) {
            var pid = product.getAttribute('data-product-id');
            if (pid && seenIds[pid]) return;
            if (pid) seenIds[pid] = true;
            product.classList.add('infinite-scroll-item');
            product.style.opacity = '0';
            currentGrid.appendChild(product.cloneNode(true));
          });

          // Animate new products
          requestAnimationFrame(function() {
            var addedProducts = currentGrid.querySelectorAll('.infinite-scroll-item');
            addedProducts.forEach(function(product, index) {
              setTimeout(function() {
                product.style.transition = 'opacity 0.3s ease';
                product.style.opacity = '1';
                product.classList.remove('infinite-scroll-item');
              }, index * 50);
            });
          });

          // Reinitialize product grid items (for quick shop, etc.)
          if (typeof theme !== 'undefined' && theme.reinitProductGridItem) {
            theme.reinitProductGridItem();
          }
        }
      }

      // Update next URL from loaded content
      var newScrollContainer = doc.querySelector('[data-infinite-scroll]');
      if (newScrollContainer) {
        this.nextUrl = newScrollContainer.getAttribute('data-next-url');
        this.currentPage = parseInt(newScrollContainer.getAttribute('data-current-page'), 10);
        this.totalPages = parseInt(newScrollContainer.getAttribute('data-total-pages'), 10);
      }

      // Check if all pages loaded
      if (!this.nextUrl || this.currentPage >= this.totalPages) {
        this.allLoaded = true;
        this.markAllLoaded();
      }
    },

    updatePagination: function() {
      // Update progress counter
      var currentCountEl = this.scrollContainer.querySelector('[data-current-count]');
      var totalCountEl = this.scrollContainer.querySelector('[data-total-count]');

      if (currentCountEl) {
        var currentGrid = this.productGrid.querySelector('.collection-grid, .grid');
        if (currentGrid) {
          var productCount = currentGrid.querySelectorAll('.grid-product, .grid__item').length;
          currentCountEl.textContent = productCount;
        }
      }

      // Update data attributes
      this.scrollContainer.setAttribute('data-current-page', this.currentPage);
      if (this.nextUrl) {
        this.scrollContainer.setAttribute('data-next-url', this.nextUrl);
      } else {
        this.scrollContainer.removeAttribute('data-next-url');
      }
    },

    setLoadingState: function(loading) {
      this.scrollContainer.setAttribute('data-loading', loading ? 'true' : 'false');

      var loadMoreBtn = this.scrollContainer.querySelector('[data-load-more-btn]');
      if (loadMoreBtn) {
        if (loading) {
          loadMoreBtn.classList.add('is-loading');
          loadMoreBtn.disabled = true;
        } else {
          loadMoreBtn.classList.remove('is-loading');
          loadMoreBtn.disabled = false;
        }
      }
    },

    markAllLoaded: function() {
      this.scrollContainer.setAttribute('data-all-loaded', 'true');

      // Disconnect observer if exists
      if (this.observer) {
        this.observer.disconnect();
      }
    },

    onCollectionReloaded: function() {
      // Reinitialize after collection is reloaded via filters
      var newContainer = document.getElementById('CollectionAjaxResult');
      if (newContainer) {
        // Destroy current instance and create new one
        if (this.observer) {
          this.observer.disconnect();
        }

        // Reinitialize with new container
        setTimeout(function() {
          new InfiniteScroll(newContainer);
        }, 100);
      }
    }
  };

  // Initialize on DOM ready
  function init() {
    var container = document.getElementById('CollectionAjaxResult');
    if (container) {
      new InfiniteScroll(container);
    }
  }

  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export for manual initialization
  window.InfiniteScroll = InfiniteScroll;
})();
